module.exports = __webpack_public_path__ + "img/onstar.3022ade7.png";